import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { formatValue } from 'helpers/listViews'
import { isValidDate, tryParseDate } from 'helpers/dateTime'
import { t } from 'helpers/i18n'
import FormView from 'containers/Assets/Warranties/FormView'

export default createChildListViewComponent({
  entityName: entityNames.assets,
  childName: 'assetWarranties',
  createButtonTextId: 'addWarranty',
  createButtonLinkTarget: {
    formSize: 'xs',
    formComponent: FormView,
  },
  primaryLinkTarget: 'assetWarrantyRecord',
  tableSummary: (self) => {
    const { items = [] } = self.props
    const expired = items.filter(
      (each) => isValidDate(each.expiryDate) && tryParseDate(each.expiryDate).getTime() < Date.now()
    )

    return `${expired.length} ${t('of')} ${items.length} ${t('expired')}`
  },
  tableCellComponents: {
    expiryDate: (self, item) => {
      const text = formatValue({
        value: item.expiryDate,
        displayFormat: self.state.fieldSettings.find((one) => one.dtoFieldName === 'expiryDate')
          .displayFormat,
      })
      return isValidDate(item.expiryDate) && tryParseDate(item.expiryDate).getTime() < Date.now() ? (
        <div className="table-cell-error">
          <span>{text}</span>
        </div>
      ) : (
        text
      )
    },
  },
})()
